// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root___BjMg","inputWrap":"Table_inputWrap__QXnTJ","col":"Table_col__3fOzr","bmiTooltip":"Table_bmiTooltip__3Q1lG"};